<template>
  <div>
    <v-tabs
      v-model="tab"
      background-color="transparent"
      color="#cb0c9f"
      class="mb-4"
    >
      <v-tab>每日打卡紀錄</v-tab>
      <v-tab>每月打卡紀錄</v-tab>
      <v-tab>匯出出勤紀錄</v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab" class="transparent">
      <v-tab-item>
        <daily-clock-records-v2 ref="daily" @view-monthly="handleViewMonthly" />
      </v-tab-item>
      <v-tab-item>
        <monthly-clock-records-v2
          ref="monthly"
          :target-user-id="selectedUserId"
        />
      </v-tab-item>
      <v-tab-item>
        <attendance-preview-v2 ref="attendancePreview" />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import DailyClockRecordsV2 from "./DailyClockRecordsV2.vue";
import MonthlyClockRecordsV2 from "./MonthlyClockRecordsV2.vue";
import AttendancePreviewV2 from "./AttendancePreviewV2.vue";

export default {
  name: "ClockRecordsTabV2",
  components: {
    DailyClockRecordsV2,
    MonthlyClockRecordsV2,
    AttendancePreviewV2,
  },
  data() {
    return {
      tab: 0,
      selectedUserId: null,
    };
  },
  created() {
    this.initFromQuery();
  },
  watch: {
    tab(newVal) {
      this.$nextTick(() => {
        if (newVal === 0 && this.$refs.daily) {
          this.$refs.daily.fetchAttendanceRecords();
        } else if (newVal === 1 && this.$refs.monthly) {
          this.$refs.monthly.fetchAttendanceRecords();
        } else if (newVal === 2 && this.$refs.attendancePreview) {
          this.$refs.attendancePreview.fetchSalaries();
        }
      });
    },
    "$route.query"() {
      this.initFromQuery();
    },
  },
  methods: {
    initFromQuery() {
      if (this.$route.query.tab !== undefined) {
        this.tab = Number(this.$route.query.tab);
      }
      if (this.$route.query.user_id !== undefined) {
        this.selectedUserId = Number(this.$route.query.user_id);
      }
    },
    handleViewMonthly(userId) {
      this.selectedUserId = userId;
      this.tab = 1;
    },
  },
};
</script>

<style scoped>
.transparent {
  background-color: transparent !important;
}
.v-tab--active {
  font-weight: bold !important;
  font-size: 1.05rem;
}
</style>
